"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultStudent = exports.getDefaultStudentFromList = void 0;
const getDefaultStudentFromList = () => ({
    id: "",
    text: "",
    originalHref: "",
    labels: [],
    originalScheduleURI: "",
    firstName: "",
    lastName: "",
    fullName: "",
    classNum: 0,
    classChar: "",
    fullClass: "",
    classNumOrig: "",
    classCharOrig: "",
    fullClassOrig: "",
});
exports.getDefaultStudentFromList = getDefaultStudentFromList;
const getDefaultStudent = () => (Object.assign(Object.assign({}, exports.getDefaultStudentFromList()), { lessons: [] }));
exports.getDefaultStudent = getDefaultStudent;
//# sourceMappingURL=Student.js.map